<template lang="pug">
div.scrollable-link.relative.padding-left-sm-2.padding-right-sm-2.scroll-root.padding-left-xs-0.padding-right-xs-0.margin-top-sm-h.margin-bottom-sm-h.margin-top-xs-h.margin-bottom-xs-h
  div.absolute.scroll.left.hidden-xs
    a(@click.prevent.stop="scrollLeft")
      img(:src="cdnImage('/img/ui/left_caret.svg')", width="100%")
  div.absolute.scroll.right.hidden-xs
    a(@click.prevent.stop="scrollRight")
      img(:src="cdnImage('/img/ui/right_caret.svg')", width="100%")
  ul.reset-list(ref="scroller", @scroll="checkScrollerVisibility")
    li.padding-left-sm-h.padding-right-sm-h(v-for="slide in slideConfig", :class="`per-row-${itemsPerPage}`", :style="{ width : getWidth() }")
      a(:href="getSlideUrl(slide.url) || '#'", :target="linkTarget || false")
        div.slide-background.b-lazy(v-if="imageLazyLoading === 'Yes'", :data-src="getBackgroundSrc(slide)", :style="{ 'padding-bottom' : getPadding() }")
        div.slide-background(v-if="imageLazyLoading !== 'Yes'", :style="{ 'background-image' : getBackground(slide), 'padding-bottom' : getPadding() }")
        h3.margin-top-sm-h.margin-top-xs-h(v-if="slide.title") {{ slide.title }}
        p(v-if="slide.text") {{ slide.text }}
</template>

<script>

import _ from 'lodash'

export default {

  components : {
  },

  props : ['itemsPerPage', 'slideConfig', 'itemWidthMobile', 'imageAspectRato', 'linkTarget', 'imageLazyLoading'],

  name: 'scrollable-links',

  data() {

    return {

      // Generic properties
      eventHub : window.vueEventHub || new Vue()

    }
  },

  computed : {
    dummyImage() {
      return "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    }
  },

  watch : {

  },

  async created() {
    await this.$nextTick()
    this.checkScrollerVisibility()

    if (this.imageLazyLoading === 'Yes') {
      window.bLazy.revalidate()
    }
  },

  methods : {

    getBackground(slide, key = 'image') {
      if (slide[key]) {
        return `url("${slide[key]}")`
      } else {
        return 'none'
      }
    },

    getBackgroundSrc(slide, key = 'image') {
      if (slide[key]) {
        return `${slide[key]}`
      } else {
        return this.dummyImage
      }
    },

    getSlideUrl(url) {
      if (url && url.indexOf('instagram.com') !== -1) return url
        
      if (url && url.indexOf('//') !== -1) {
        // get relative url
        url = url.replace(/^(?:\/\/|[^\/]+)*\//, "")
      }
      // to locale url
      if (url && window.urlResourceLocator) {
        url = window.urlResourceLocator.getResourceUrl(url)
      }
      return url
    },

    getPadding() {
      return this.imageAspectRato + '%'
    },

    getWidth() {
      return this.itemWidthMobile + 'vw'
    },

    cdnImage(src) {
      return `${CDN_URL_PREFIX}${src}`
    },

    scrollLeft(event) {
      let e = this.$refs.scroller
      let w = e.getBoundingClientRect().width
      $(e).animate({ scrollLeft : `-=${w}px`}, 500)
    },

    scrollRight(event) {
      let e = this.$refs.scroller
      let w = e.getBoundingClientRect().width
      $(e).animate({ scrollLeft : `+=${w}px`}, 500)
    },

    checkScrollerVisibility(event) {

      let el
      if (!!event) {
        el = event.target
      }

      if (!el) {
        el = this.$refs.scroller
      }

      if (!el) return

      let parent = el.closest('.scroll-root')
      let canScrollLeft = el.scrollLeft > 0;
      let canScrollRight = (el.scrollLeft + el.clientWidth) < el.scrollWidth
      if (!canScrollLeft) {
        parent.classList.add('no-left')
      } else {
        parent.classList.remove('no-left')
      }

      if (!canScrollRight) {
        parent.classList.add('no-right')
      } else {
        parent.classList.remove('no-right')
      }

      if (this.imageLazyLoading === 'Yes') {
        window.bLazy.revalidate()
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.cms-sliding-listing-block {

  .scrollable-link {
    @media (min-width: 768px) {
      margin-left: -10px;
      margin-right: -10px;
    }
    ul li {
      display: inline-block;
    }
  }

  ul {
    white-space: nowrap;
    overflow-x: hidden;
    @media (max-width: 767px) {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
  }

  li {
    vertical-align: top;
    padding-left: 10px;
    padding-right: 10px;
    display: inline-block;
    white-space: normal;
  }

  @media (min-width: 768px) {

    .per-row-1 {
      width: 100%!important;
    }
    .per-row-2 {
      width: 50%!important;
    }
    .per-row-3 {
      width: 33.33%!important;
    }
    .per-row-4 {
      width: 25%!important;
    }
    .per-row-5 {
      width: 20%!important;
    }

  }

  .slide-background {
    width: 100%;
    height: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }

  @media (max-width: 767px) {
    .scroll { display: none }
  }
  .scroll-root:hover .scroll img { opacity: .8 }
  .scroll-root.no-left .scroll.left img { opacity: 0; pointer-events: none }
  .scroll-root.no-right .scroll.right img { opacity: 0; pointer-events: none }
  .scroll {
    height: 100%;
    width: 40px;
    top: 0;
    &.left {
      left: 0;
    }
    &.right {
      right: 0;
    }
    img {
      opacity: .05;
      transition: opacity .2s ease-out;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      position: absolute;
      z-index: 1;
    }
  }

}
</style>


// WEBPACK FOOTER //
// CMSScrollableLink.vue?aefe9ec0